import Backbone from 'backbone';

import SecondaryStructure from 'analyses/SecondaryStructure';
import {NucleotideType} from 'biojs/BioConstants';
import {ComponentsSequence} from 'components/Sequence';
import {TabState, TabStateDefaults} from 'Navigation';

class SecondaryStructures extends Backbone.Collection<SecondaryStructure> {
  static initClass(): void {
    this.prototype.model = SecondaryStructure;
  }
}
SecondaryStructures.initClass();

class SecondaryStructureTabState extends TabState {
  override defaults(): TabStateDefaults {
    return {...super.defaults(), title: 'All Structures'};
  }

  static create(
    sequence: ComponentsSequence,
    mainStructure: {dg: number; svg: string},
    otherStructures: Array<{dg: number; svg: string}>,
    name: string,
    temperature: number,
    nucleotideType: NucleotideType,
    primer: string,
    primer2?: string
  ): void {
    const tab = new SecondaryStructureTabState({
      sequence,
      mainStructure: new SecondaryStructure({...mainStructure, nucleotideType, name}),
      structures: new SecondaryStructures(
        otherStructures.map((structure) => ({...structure, nucleotideType, name}))
      ),
      temperature,
      primer,
      primer2,
      name,
    });
    sequence.fileState().buffers().addTab(tab);
  }
}

export default SecondaryStructureTabState;
